<template>
  <div class="container">
    <Header class="header" data-title="렌탈" @rental="rental" :type="'order'" ref="header"></Header>
    <!-- content(s) -->
    <div id="content" style="padding-bottom: 72px">
      <div class="progress uiAct" role="img" aria-label="총 3단계 중 2단계 결제정보입력 진행중">
        <ol aria-hidden="true">
          <li><span>동의 및 본인인증</span></li>
          <li class="on"><span>결제정보입력</span></li>
          <li><span>계약서작성</span></li>
        </ol>
      </div>

      <section class="hr">
        <div class="titArea mt0">
          <h2 class="titH4">결제방법을 선택해주세요.</h2>
        </div>

        <div class="formArea">
          <template v-if="rmanCd == ''">
            <span class="label">쿠폰</span>
            <div class="sltWrap">
              <select class="ipt notDel uiAct" title="쿠폰 선택" v-model="couponCd">
                <option value="" disabled="disabled">쿠폰을 선택해주세요.</option>
                <option v-for="(item, index) in couponList" v-bind:key="index" v-bind:value="item.couponId" v-text="item.title"></option>
              </select>
            </div>
          </template>

          <span class="label">추천코드</span>
          <div class="setBtnS">
            <input type="text" class="ipt notDel uiAct" title="추천코드 입력" placeholder="추천코드 입력" value="" v-model="rmanCd" />
            <button type="button" class="btn_g m" @click="recommandSearch">등록</button>
            <p class="txtList_remark" v-if="rmanCdFlag">할인금액은 1,2 개월 납입회차에 자동 적용됩니다.</p>
            <p class="txtList_remark" v-if="rmanCdFlag">소개자는 {{ rmanCdResult }} 입니다.</p>
          </div>
        </div>

        <div class="totalSum bgNone">
          <!-- <div v-if="couponCd != ''">
            <strong class="tit">할인금액</strong>
            <span class="money pointC1">
              <em v-text="discountAmount"></em>
              원
            </span>
          </div>-->
          <div class="total">
            <strong class="tit">월 렌탈료</strong>
            <span class="money">
              <em>{{ rentalAmount | currency }}</em>
              원
            </span>
          </div>
        </div>
      </section>

      <section class="hr">
        <div class="titArea mt0">
          <h2 class="titH4">결제수단 선택</h2>
        </div>
        <!-- tabWrap (s) -->
        <div class="tabWrap iptBtn">
          <ul class="tabList iptBtn" role="tablist">
            <li class="on" id="tab_0_0" role="tab" aria-controls="panel_0_0" tabindex="0" aria-selected="true" @click="selectCheckType('RDUT00CC')">
              <span class="ico">카드결제</span>
              <span class="blind guideTxt">선택됨</span>
            </li>
            <li id="tab_0_1" role="tab" aria-controls="panel_0_1" tabindex="0" aria-selected="false" @click="selectCheckType('RDUT00CM')">
              <span class="ico">CMS자동이체</span>
            </li>
          </ul>
          <p class="blind guideTxt">카드결제 탭 내용 시작</p>
          <div class="tabContents">
            <!--<ValidationObserver ref="cardForm">-->
            <div class="tabPanel on" id="panel_0_0" role="tabpanel" aria-hidden="false" aria-labelledby="tab_0_0">
              <div class="formArea">
                <span class="label">카드선택</span>
                <!--<ValidationProvider name="카드선택" rules="required" v-slot="{ errors }">-->
                <div class="sltWrap">
                  <select class="ipt notDel uiAct" title="카드선택" v-model="cardName" ref="cardName">
                    <option value="" disabled="disabled">선택해주세요</option>
                    <option
                      v-for="(cardObj, index) in cardNameList"
                      v-bind:key="index"
                      v-bind:value="cardObj.code"
                      v-text="cardObj.codeName"
                    ></option>
                  </select>
                </div>

                <!--</ValidationProvider>-->
                <p class="txtList_remark">본인 결제수단만 진행 가능</p>
                <!--<ValidationProvider name="카드번호" rules="required" v-slot="{ errors }">-->
                <span class="label">카드번호</span>
                <div class="transkey">
                  <div class="setCard" ref="cardNumber">
                    <input
                      type="tel"
                      class="ipt notDel uiAct"
                      maxlength="4"
                      title="카드번호 첫번째 4자리"
                      value=""
                      v-model="cardNumberPart1"
                      v-onlyNum
                      v-skipOfMax
                      nextTarget="cardNumberPart2"
                      onfocus="this.scrollIntoView({block: 'center'})"
                      @focus="focus = true"
                      @blur="focus = false"
                    />
                    <span class="sign" aria-hidden="true">-</span>
                    <input
                      type="tel"
                      class="ipt notDel uiAct"
                      maxlength="4"
                      title="카드번호 두번째 4자리"
                      id="cardNumberPart2"
                      value=""
                      v-model="cardNumberPart2"
                      v-onlyNum
                      v-skipOfMax
                      nextTarget="cardNum3"
                      onfocus="this.scrollIntoView({block: 'center'})"
                      @focus="focus = true"
                      @blur="focus = false"
                    />
                    <span class="sign" aria-hidden="true">-</span>
                    <input
                      type="tel"
                      class="ipt"
                      maxlength="4"
                      id="cardNum3"
                      nextTarget="cardNum4"
                      title="카드번호 세번째 4자리"
                      v-skipOfMax
                      data-tk-kbdType="number"
                      onfocus="mtk.onKeyboard(this); this.scrollIntoView({block: 'center'});"
                    />
                    <span class="sign" aria-hidden="true">-</span>
                    <input
                      type="tel"
                      class="ipt"
                      maxlength="4"
                      id="cardNum4"
                      title="카드번호 마지막 4자리"
                      data-tk-kbdType="number"
                      onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                    />
                  </div>
                </div>

                <!--</ValidationProvider>-->
                <span class="label">유효기간</span>
                <!--<ValidationProvider name="카드유효기간" rules="required|min:2" v-slot="{ errors }">-->
                <div class="transkey">
                  <div class="setPeriod" ref="cardExpireDate">
                    <input
                      type="tel"
                      class="ipt"
                      maxlength="2"
                      id="expirdateMM"
                      nextTarget="expirdateYY"
                      title="유효기간 월 2자리"
                      placeholder="MM"
                      v-skipOfMax
                      data-tk-kbdType="number"
                      onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                    />
                    <span class="sign" aria-hidden="true">/</span>
                    <input
                      type="tel"
                      class="ipt"
                      maxlength="2"
                      id="expirdateYY"
                      title="유효기간 년 2자리"
                      placeholder="YY"
                      v-skipOfMax
                      data-tk-kbdType="number"
                      onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                    />
                  </div>
                </div>

                <!--</ValidationProvider>-->
                <span class="label">결제일</span>
                <!--<ValidationProvider name="결제일" rules="required" v-slot="{ errors }">-->
                <div class="sltWrap">
                  <select class="ipt notDel uiAct" title="결제일 선택" v-model="cardDueDate" ref="cardDueDate">
                    <option value="" disabled="disabled">선택해주세요</option>
                    <option
                      v-for="(dueDateObj, index) in dueDateList"
                      v-bind:key="index"
                      v-bind:value="dueDateObj.code"
                      v-text="dueDateObj.codeName"
                    ></option>
                  </select>
                </div>

                <!--</ValidationProvider>-->

                <!-- <span class="singleIpt">
                  <input type="checkbox" class="ipt notDel uiAct" name="chk" id="chk1" value="Y" />
                  <label for="chk1">입력한 결제 정보를 다음에도 사용</label>
                </span> -->
              </div>
            </div>
            <!--</ValidationObserver>-->
            <!--<ValidationObserver ref="bankForm">-->
            <div class="tabPanel" id="panel_0_1" role="tabpanel" aria-hidden="true" aria-labelledby="tab_0_1">
              <div class="formArea">
                <span class="label">은행선택</span>
                <!--<ValidationProvider name="은행선택" rules="required" v-slot="{ errors }">-->
                <div class="sltWrap">
                  <select class="ipt notDel uiAct" title="은행선택" v-model="bankCode" ref="bankCode">
                    <option value="" disabled="disabled">선택해주세요</option>
                    <option
                      v-for="(bankCodeObj, index) in bankCodeList"
                      v-bind:key="index"
                      v-bind:value="bankCodeObj.code"
                      v-text="bankCodeObj.codeName"
                    ></option>
                  </select>
                </div>

                <!--</ValidationProvider>-->
                <p class="txtList_remark">본인 결제수단만 진행 가능</p>

                <span class="label" ref="accountNumber">계좌번호</span>
                <!--<ValidationProvider name="계좌번호" rules="required|numeric" v-slot="{ errors }">-->
                <input type="tel" class="ipt notDel uiAct" title="계좌번호 입력" value="" v-model="bankAccnt" v-onlyNum v-show="!useSecureKeyPad" />

                <!--</ValidationProvider>
                  <ValidationProvider name="계좌번호" rules="required" v-slot="{ errors }">-->
                <div class="transkey">
                  <input
                    type="tel"
                    class="ipt"
                    id="accountNum"
                    maxlength="16"
                    title="계좌번호 입력"
                    placeholder="- 없이 입력해주세요"
                    value=""
                    data-tk-kbdType="number"
                    onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                    v-show="useSecureKeyPad"
                  />
                </div>

                <!--</ValidationProvider>-->
                <span class="singleIpt mt10 ar">
                  <input type="checkbox" class="ipt notDel uiAct" name="chk" id="chk2" v-model="useSecureKeyPad" />
                  <label for="chk2">보안키패드로 입력</label>
                </span>

                <span class="label">이체일</span>
                <!--<ValidationProvider name="이체일" rules="required" v-slot="{ errors }">-->
                <div class="sltWrap">
                  <select class="ipt notDel uiAct" title="이체일 선택" v-model="bankDueDate" ref="bankDueDate">
                    <option value="" disabled="disabled" selected="selected">선택해주세요</option>
                    <option
                      v-for="(dueDateObj, index) in dueDateList"
                      v-bind:key="index"
                      v-bind:value="dueDateObj.code"
                      v-text="dueDateObj.codeName"
                    ></option>
                  </select>
                </div>

                <!--</ValidationProvider>-->

                <span class="label" ref="cashReq">현금영수증</span>
                <ul class="iptGroup iptBtn">
                  <li>
                    <input type="radio" class="ipt notDel uiAct" name="rdo2" id="rdo2_1" checked="checked" value="Y" v-model="cashReqYn" />
                    <label for="rdo2_1"><span class="ico">발행</span></label>
                  </li>
                  <li>
                    <input type="radio" class="ipt notDel uiAct" name="rdo2" id="rdo2_2" value="N" v-model="cashReqYn" />
                    <label for="rdo2_2"><span class="ico">미발행</span></label>
                  </li>
                </ul>

                <div v-if="cashReqYn == 'Y'">
                  <span class="label" ref="mobile">휴대폰번호</span>
                  <input type="tel" class="ipt notDel uiAct" title="휴대폰번호 입력" value="" v-model="cashNum" v-onlyNum />
                </div>

                <!-- <span class="singleIpt">
                  <input type="checkbox" class="ipt notDel uiAct" name="chk" id="chk3" />
                  <label for="chk3">입력한 결제 정보를 다음에도 사용</label>
                </span> -->
              </div>
            </div>
            <!--</ValidationObserver>-->
          </div>
        </div>
        <!-- tabWrap (e) -->

        <div class="btnArea" :class="{ sticky: !focus }">
          <button type="button" class="btn_p" @click="goNextDepth">다음</button>
        </div>
      </section>
      <MessagePop v-if="messagePop" @close="messagePop = false">
        <p v-html="msg"></p>
      </MessagePop>
      <ConfirmPop @cancel="cancel" @confirm="confirm" v-if="confirmPop" @close="confirmPop = false">
        <p v-html="msg"></p>
      </ConfirmPop>
    </div>
    <!-- content(e) -->
  </div>
</template>

<script>
//import * as customjs from '@/../static/js/m.front.js';
import ApiService from '@/common/api.service';
import MessagePop from '@/components/popup/MessagePop';
import ConfirmPop from '@/components/popup/ConfirmPop';
import { GO_HOME, RECOMMAND_CHECK, SERVICE_COMM_ERROR } from '@/store/message.type.js';
import JwtService from '@/common/jwt.service';
import { isEmpty } from '@/common/common.function';
import { find } from 'lodash';
import $ from 'jquery';

export default {
  name: 'MemberStep2',
  components: {
    MessagePop,
    ConfirmPop,
  },
  // mixins: [popup],
  mounted() {
    // console.log('cponID ' + couponId);
    if (!isEmpty(this.couponId)) this.couponCd = this.couponId;

    const friendObj = this.$cookies.get('friendObj');
    if (friendObj != null) this.rmanCd = friendObj.friendCode;

    // 상품 정보 조회
    ApiService.service('GET', '/product/' + this.prodCode)
      .then(({ data }) => {
        console.log(data);
        if (data.isSucceed) {
          this.product = data.result;
          for (let i = 0; i < data.result.prodOptionCollect.length; i++) {
            if (data.result.prodOptionCollect[i].prodCode == this.paramObj.request.orderCommInfo.internalProdCode) {
              this.rentalAmount = data.result.prodOptionCollect[i].rentalAmount;
            }
          }

          ApiService.service('GET', '/product/' + this.product.product.productCode + '/coupon/type/CPAP0001')
            .then(({ data }) => {
              console.log('cpon ===>> ' + data);
              // debugger;
              this.couponList = data.result;
              for (let i = 0; i < this.couponList.length; i++) {
                if (this.couponId == this.couponList[i].couponId) {
                  this.couponTitle = this.couponList[i].title;
                  break;
                }
              }
            })
            .catch(({ response }) => {
              console.log(response);
            });
        }
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
      });

    // 쿠폰 리스트 조회
    /* 
      ApiService.service('GET', '/order/coupon/' + this.paramObj.prodCode)
        .then(({ data }) => {
          if (data.isSucceed) {
            for (let i = 0; i < data.result.length; i++) {
              let couponObj = data.result[i];
              if (couponObj.applyType == 'CPAP0001' || couponObj.applyType == 'CPAP0004') {
                let startDateStr = data.result[i].startDate.substring(0, 8);
                let endDateStr = data.result[i].endDate.substring(0, 8);
                let startDate = new Date(startDateStr.substring(0, 4), Number(startDateStr.substring(4, 6)) - 1, startDateStr.substring(6));
                let endDate = new Date(endDateStr.substring(0, 4), Number(endDateStr.substring(4, 6)) - 1, endDateStr.substring(6));
                // 테스트용
                //let today = new Date('2020', '7', '1');
                let today = new Date();

                if (startDate.getTime() < today.getTime() && endDate.getTime() > today.getTime()) {
                  this.couponList.push(data.result[i]);
                }
              }
            }
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
      */

    // 카드종류 조회
    ApiService.service('GET', '/common/code/RCAD')
      .then(({ data }) => {
        if (data.isSucceed) {
          this.cardNameList = data.result[0].codeList;
        }
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
      });

    // 은행종류 조회
    ApiService.service('GET', '/common/code/RBAK')
      .then(({ data }) => {
        if (data.isSucceed) {
          this.bankCodeList = data.result[0].codeList;
        }
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
      });

    // 이체일 조회
    ApiService.service('GET', '/common/code/RDUE')
      .then(({ data }) => {
        if (data.isSucceed) {
          this.dueDateList = data.result[0].codeList;
        }
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
      });

    this.cashNum = this.userInfo.mobile;

    if (process.env.NODE_ENV != 'dev') {
      import('@/raon/welcomeTranskey').then((m) => {
        m.importCSS();
        m.importJS(0, ['cardNum3', 'cardNum4', 'expirdateMM', 'expirdateYY', 'accountNum']);
      });
    }

    //window.importCSS();
    //window.importJS(0, ['cardNum3', 'cardNum4', 'expirdateMM', 'expirdateYY', 'accountNum']); // 보안키패드
  },
  watch: {
    rmanCd() {
      this.couponCd = '';
    },
    couponTitle() {
      console.log(this.couponTitle);
    },
  },
  data: function () {
    return {
      userInfo: JwtService.getUserInfo(),

      // step1에서 입력한 정보
      paramObj: this.$route.params.paramObj,
      prodCode: this.$route.params.prodCode,
      couponId: this.$route.params.couponId,
      couponSerialNumber: this.$route.params.couponSerialNumber,

      // 상품 상세 정보
      product: null,
      rentalAmount: null,

      // 상품에 대한 쿠폰정보
      couponList: [],
      couponCd: '',
      couponTitle: '',
      discountAmount: '',

      // 결제 정보 관련
      checkType: 'RDUT00CC',

      cardNumberPart1: null,
      cardNumberPart2: null,
      cardNumberPart3: null,
      cardNumberPart4: null,
      cardNum3: null,
      cardNum4: null,

      expirdateMM: null,
      expirdateYY: null,

      bankAccnt: null,
      cashReqYn: 'N',
      cashNum: null,

      // 카드 종류 리스트
      cardNameList: null,
      cardName: '',

      // 은행 리스트
      bankCodeList: null,
      bankCode: '',

      // 이체일
      dueDateList: null,
      cardDueDate: '',
      bankDueDate: '',

      // 추천코드
      rmanCd: '',
      rmanCdResult: null,
      rmanCdFlag: false,

      // 결제정보 확인 실패 횟수
      failCnt: 0,

      // 팝업 관련
      messagePop: null,
      confirmPop: null,
      msg: null,
      popMsg: null,

      // 보안키패드
      encCardNumber3: {},
      encCardNumber4: {},
      encCardExpiredYY: {},
      encCardExpiredMM: {},
      encAccountNumber: {},
      useSecureKeyPad: false,
      mtk: null,
      focus: false,
    };
  },
  methods: {
    goNextDepth: function () {
      const data = find(this.couponList, { couponId: this.couponCd });
      console.log('data.couponId] ', data.couponId);
      console.log('data.couponId] ', data.couponSerialNumber);
      if (process.env.NODE_ENV != 'dev') {
        this.encCardNumber3 = this.makeData('cardNum3', 'Y');
        this.encCardNumber4 = this.makeData('cardNum4', 'Y');
        this.encCardExpiredYY = this.makeData('expirdateYY', 'Y');
        this.encCardExpiredMM = this.makeData('expirdateMM', 'Y');
        this.encAccountNumber = this.makeData('accountNum', 'Y');

        //TODO : 아래 코드 용도 확인 필요 2020-10-29 > 주완과 주완 이 전을 상태 코드값으로 구분하고 있음 (20210315 최재니)
        this.paramObj.request.orderCommInfo.orderStatus = 'RSTA00PR';

        if (this.checkType == 'RDUT00CC') {
          // 카드결제
          let inputFlag = false;
          let invalidMsg = '';
          let invalidObj = null;

          if (isEmpty(this.cardName)) {
            inputFlag = true;
            invalidMsg = '카드를 선택해주세요.';
            invalidObj = this.$refs.cardName;
          }

          if (
            (isEmpty(this.cardNumberPart1) ||
              isEmpty(this.cardNumberPart2) ||
              isEmpty(this.encCardNumber3.inputValue) ||
              isEmpty(this.encCardNumber4.inputValue)) &&
            !inputFlag
          ) {
            inputFlag = true;
            invalidMsg = '카드번호를 확인해주세요.';
            invalidObj = this.$refs.cardNumber;
          }

          if ((isEmpty(this.encCardExpiredYY.inputValue) || isEmpty(this.encCardExpiredMM.inputValue)) && !inputFlag) {
            inputFlag = true;
            invalidMsg = '카드 유효기간을 확인해주세요.';
            invalidObj = this.$refs.cardExpireDate;
          }

          if (isEmpty(this.cardDueDate) && !inputFlag) {
            inputFlag = true;
            invalidMsg = '결제일을 확인해주세요.';
            invalidObj = this.$refs.cardDueDate;
          }

          if (inputFlag) {
            invalidObj.focus();
            this.msg = invalidMsg;
            this.messagePop = true;
            return false;
          }
          let cardNumber = this.cardNumberPart1 + this.cardNumberPart2 + this.cardNum3 + this.cardNum4;
          let cardExpireDate = this.expirdateMM + this.expirdateYY;

          let payInfo = this.paramObj.request.payInfo;
          payInfo.cardExpireDate = cardExpireDate;
          payInfo.cardName = this.cardName;
          payInfo.cardNumber = cardNumber;
          payInfo.checkType = this.checkType;
          payInfo.dueDate = this.cardDueDate;
          payInfo.rmanCd = this.rmanCd;
          payInfo.couponCd = data ? data.couponId : '';
          payInfo.couponTitle = this.couponTitle;
          payInfo.couponSerialNumber = data ? data.couponSerialNumber : '';
          payInfo.secureKeyPad = this.useSecureKeyPad ? 'Y' : 'N';
          payInfo.encCardNumber3 = this.encCardNumber3;
          payInfo.encCardNumber4 = this.encCardNumber4;
          payInfo.encCardExpireMM = this.encCardExpiredMM;
          payInfo.encCardExpireYY = this.encCardExpiredYY;
          payInfo.cardNumber1 = this.cardNumberPart1;
          payInfo.cardNumber2 = this.cardNumberPart2;
        } else if (this.checkType == 'RDUT00CM') {
          // CMS 자동이체
          let inputFlag = false;
          let invalidMsg = '';
          let invalidObj = null;

          if (isEmpty(this.bankCode)) {
            inputFlag = true;
            invalidMsg = '은행을 선택해주세요.';
            invalidObj = this.$refs.bankCode;
          }

          if (!this.useSecureKeyPad && isEmpty(this.bankAccnt) && !inputFlag) {
            inputFlag = true;
            invalidMsg = '계좌번호를 입력해주세요.';
            invalidObj = this.$refs.accountNumber;
          }

          if (this.useSecureKeyPad && isEmpty(this.encAccountNumber.inputValue) && !inputFlag) {
            inputFlag = true;
            invalidMsg = '계좌번호를 입력해주세요.';
            invalidObj = this.$refs.accountNumber;
          }

          if (this.bankAccnt.substring(0, 3) == '010' && this.bankAccnt.length < 12) {
            inputFlag = true;
            invalidMsg = `평생계좌는 사용할 수 없습니다.<br>다른 계좌번호를 입력해주세요.`;
            invalidObj = this.$refs.accountNumber;
          }

          if (isEmpty(this.bankDueDate) && !inputFlag) {
            inputFlag = true;
            invalidMsg = '이체일을 선택해주세요.';
            invalidObj = this.$refs.bankDueDate;
          }

          if (isEmpty(this.cashReqYn) && !inputFlag) {
            inputFlag = true;
            invalidMsg = '현금영수증 발행 여부를 선택해주세요.';
            invalidObj = this.$refs.cashReq;
          }

          if (this.cashReqYn == 'Y' && isEmpty(this.cashNum) && !inputFlag) {
            inputFlag = true;
            invalidMsg = '현금영수증 발행 휴대폰번호를 입력해주세요.';
            invalidObj = this.$refs.mobile;
          }

          if (inputFlag) {
            invalidObj.focus();
            this.msg = invalidMsg;
            this.messagePop = true;
            return false;
          }

          let payInfo = this.paramObj.request.payInfo;
          payInfo.bankAccnt = this.bankAccnt;
          payInfo.bankCode = this.bankCode;
          payInfo.cashNum = this.cashNum;
          payInfo.cashReqYn = this.cashReqYn;
          payInfo.checkType = this.checkType;
          payInfo.dueDate = this.bankDueDate;
          payInfo.rmanCd = this.rmanCd;
          // payInfo.couponCd = this.couponCd;
          // payInfo.couponTitle = this.couponTitle;
          payInfo.couponSerialNumber = this.couponSerialNumber;
          payInfo.couponCd = data ? data.couponId : '';
          payInfo.couponTitle = this.couponTitle;
          payInfo.couponSerialNumber = data ? data.couponSerialNumber : '';
          payInfo.secureKeyPad = this.useSecureKeyPad ? 'Y' : 'N';
          payInfo.encAccountNumber = this.encAccountNumber;
        }
      } else {
        if (this.checkType == 'RDUT00CC') {
          let cardNumber =
            this.cardNumberPart1 + this.cardNumberPart2 + document.getElementById('cardNum3').value + document.getElementById('cardNum4').value;
          let cardExpireDate = document.getElementById('expirdateMM').value + document.getElementById('expirdateYY').value;
          let payInfo = this.paramObj.request.payInfo;
          payInfo.cardExpireDate = cardExpireDate;
          payInfo.cardName = this.cardName;
          payInfo.cardNumber = cardNumber;
          payInfo.checkType = this.checkType;
          payInfo.dueDate = this.cardDueDate;
          payInfo.rmanCd = this.rmanCd;
          // payInfo.couponCd = this.couponCd;
          // payInfo.couponTitle = this.couponTitle;
          // payInfo.couponSerialNumber = this.couponSerialNumber;
          payInfo.couponCd = data ? data.couponId : '';
          payInfo.couponTitle = this.couponTitle;
          payInfo.couponSerialNumber = data ? data.couponSerialNumber : '';
          payInfo.secureKeyPad = this.useSecureKeyPad ? 'Y' : 'N';
          payInfo.encCardNumber3 = this.encCardNumber3;
          payInfo.encCardNumber4 = this.encCardNumber4;
          payInfo.encCardExpireMM = this.encCardExpiredMM;
          payInfo.encCardExpireYY = this.encCardExpiredYY;
          payInfo.cardNumber1 = this.cardNumberPart1;
          payInfo.cardNumber2 = this.cardNumberPart2;
        } else {
          let payInfo = this.paramObj.request.payInfo;
          payInfo.bankAccnt = this.bankAccnt;
          payInfo.bankCode = this.bankCode;
          payInfo.cashNum = this.cashNum;
          payInfo.cashReqYn = this.cashReqYn;
          payInfo.checkType = this.checkType;
          payInfo.dueDate = this.bankDueDate;
          payInfo.rmanCd = this.rmanCd;
          // payInfo.couponCd = this.couponCd;
          // payInfo.couponTitle = this.couponTitle;
          // payInfo.couponSerialNumber = this.couponSerialNumber;
          payInfo.couponCd = data ? data.couponId : '';
          payInfo.couponTitle = this.couponTitle;
          payInfo.couponSerialNumber = data ? data.couponSerialNumber : '';
          payInfo.secureKeyPad = this.useSecureKeyPad ? 'Y' : 'N';
          payInfo.encAccountNumber = this.encAccountNumber;
        }
      }

      this.$refs.header.loadingStart(); // 로딩시작
      ApiService.service('POST', '/order/rental', this.paramObj)
        .then(({ data }) => {
          if (data.isSucceed) {
            this.$router.push({
              name: 'memberStep3',
              params: { paramObj: this.paramObj, prodCode: this.prodCode },
            });
          } else if (data.errorCode == '-20006') {
            this.$router.push({ name: 'rentalFail' });
          } else {
            this.msg = data.error;
            //this.msg = ORDER_FAIL;
            this.messagePop = true;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
          this.msg = SERVICE_COMM_ERROR;
          this.messagePop = true;
        })
        .finally(() => {
          this.$refs.header.loadingEnd(); // 로딩끝
        });
    },
    selectCoupon: function () {
      this.rentalAmount = this.product.productDetail.rentalAmount;
      for (let i = 0; i < this.couponList.length; i++) {
        if (this.couponCd == this.couponList[i].couponId) {
          this.couponTitle = this.couponList[i].title;
          this.couponSerialNumber = this.couponList[i].couponSerialNumber;
          if (this.couponList[i].discountType == 'CM630001') {
            // 정액 할인
            let discountAmt = this.couponList[i].discountAmount;
            let amount = Number(this.rentalAmount) - Number(discountAmt);
            this.rentalAmount = amount < 0 ? 0 : amount;
            this.discountAmount = '-' + discountAmt;
          } else if (this.couponList[i].discountType == 'CM630002') {
            // 정률 할인
            let discountRate = this.couponList[i].discountRate;
            let discountAmt = Number(this.rentalAmount) * (Number(discountRate) / 100);
            let amount = Number(this.rentalAmount) - Math.round(discountAmt);
            this.rentalAmount = amount < 0 ? 0 : amount;
            this.discountAmount = '-' + discountAmt;
          }
          break;
        }
      }
    },
    selectCheckType: function (code) {
      // 탭 이동시 입력 폼 초기화
      this.checkType = code;

      this.cardNumberPart1 = '';
      this.cardNumberPart2 = '';
      this.cardNum3 = '';
      this.cardNum4 = '';
      $('#cardNum3').val('');
      $('#cardNum4').val('');

      this.expirdateMM = '';
      this.expirdateYY = '';
      $('#expirdateMM').val('');
      $('#expirdateYY').val('');

      this.bankAccnt = '';
      this.cashReqYn = 'Y';
      this.cashNum = this.userInfo.mobile;

      this.cardName = '';
      this.bankCode = '';
      this.cardDueDate = '';
      this.bankDueDate = '';

      //this.$refs.cardForm.reset();
      //this.$refs.bankForm.reset();
    },
    rental: function () {
      //장바구니에 담을건지 ConfirmPop 노출
      this.msg = GO_HOME;
      this.confirmPop = true;
    },
    cancel: function () {
      this.confirmPop = false;
    },
    confirm: function () {
      // 확인 선택시 장바구니에 담고 페이지이동
      // TODO 장바구니 추가 API 호출
      this.$router.replace('/');
    },
    recommandSearch: function () {
      if (isEmpty(this.rmanCd)) {
        this.msg = RECOMMAND_CHECK;
        this.messagePop = true;
        return false;
      }

      ApiService.service('GET', '/order/recommand/' + this.rmanCd)
        .then(({ data }) => {
          if (data.isSucceed) {
            this.rmanCdResult = data.result.maskedUserName;
            this.rmanCdFlag = true;
            this.couponCd = '';
          } else {
            this.rmanCd = '';
            this.msg = data.error;
            this.messagePop = true;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    makeData(id, encrytedYN, plainValue) {
      if (process.env.NODE_ENV == 'dev') return null;

      // eslint-disable-next-line no-undef
      let values = mtk.inputFillEncData(document.getElementById(id));
      let name = document.getElementById(id).name;
      let hidden = values.hidden;
      let hmac = values.hmac;

      // eslint-disable-next-line no-undef
      let keyboardType = transkey[id].keyboard;
      // eslint-disable-next-line no-undef
      let keyIndex = transkey[id].keyIndex;
      // eslint-disable-next-line no-undef
      let fieldType = transkey[id].fieldType;
      // eslint-disable-next-line no-undef
      let inputObjValue = transkey[id].inputObj.value;
      let seedKey = document.getElementById('seedKey').value;
      let initTime = document.getElementById('initTime').value;
      let ExE2E = values.ExE2E;

      let newRaonRequest = {};
      newRaonRequest.id = id;
      newRaonRequest.name = name;
      newRaonRequest.keyboardType = keyboardType;
      newRaonRequest.keyIndex = keyIndex;
      newRaonRequest.fieldType = fieldType;
      newRaonRequest.seedKey = seedKey;
      newRaonRequest.initTime = initTime;
      newRaonRequest.transkey = hidden;
      newRaonRequest.transkey_HM = hmac.toString();
      newRaonRequest.transkey_EXE2E = ExE2E;
      newRaonRequest.plainValue = plainValue;
      newRaonRequest.encrytedYN = encrytedYN;
      newRaonRequest.inputValue = inputObjValue;
      return newRaonRequest;
    },
  },
};
</script>
